import { render, staticRenderFns } from "./CatalogManager.vue?vue&type=template&id=b13fd6fa&"
import script from "./CatalogManager.vue?vue&type=script&lang=js&"
export * from "./CatalogManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports